import { autoinject, PLATFORM, transient, useView } from "aurelia-framework";
import { EntityTypes } from "@rightship-tech/common-ui/models/basic.models";
import * as DOMPurify from "dompurify";
import * as moment from "moment";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { SignalFunctions } from "../../../../../constants/signal.constants";
import { SignalClientService } from "@rightship-tech/common-ui/services/basic/signal-client.service";
import { QueriesClientService } from "@rightship-tech/common-ui/services/queries/queries-client.services";
import { DueDiligenceClientModel } from "../../../../../models/due-diligence.models";

@autoinject
@transient()
@useView(PLATFORM.moduleName("@rightship-tech/due-diligence-app/views/pages/due-diligence/tabs/history-trail/due-diligence-history-trail.html"))
export class DueDiligenceHistoryTrail  {

    public item: DueDiligenceClientModel;
    
    public activate(model: any) {
        this.item = typeof (model) == "string" ? this.parse(<string>model) : model.dueDiligenceHistoryTrail;
        this.refreshData();
    }

    private parse(obj: string): DueDiligenceClientModel {
        return JSON.parse(obj.replace(new RegExp("&quot;", "g"), "\"")
            .replace(new RegExp("&gt;", "g"), ">")
            .replace(new RegExp("&lt;", "g"), "<"));
    }

    public audits: any[] = [];

    constructor(protected configService: ConfigService, private signalClientService:SignalClientService, 
        private queriesClientService:QueriesClientService) {
    }

    getActionDetails(item) {
        const actionDetails = item.actionDetails;

        const div = document.createElement('div');
        div.innerHTML = DOMPurify.sanitize(actionDetails);

        let spans: Element[] = Array.from(div.querySelectorAll("span[data-type='12']"));
        spans = spans.concat(Array.from(div.querySelectorAll("span[data-type='7']")));
        
        spans.forEach(span => {
            const value = span.textContent;
            const date = moment.utc(value, ["DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY H:mm:ss", "DD/MM/YYYY hh:mm:ss A", "DD/MM/YYYY h:mm:ss A"]).local();
            const parameters = span.getAttribute('parameters');

            const dataType = Number(span.getAttribute('data-type'));
            let datestring = null;

            if (parameters && parameters != null && parameters != "") {
                datestring = date.format(parameters);
            }
            else {
                datestring = date.format(dataType == 7 ? this.configService.config.common.defaultDateFormat : this.configService.config.common.defaultDateTimeFormat);
            }
            span.textContent = datestring;
        });

        return div.innerHTML;
    }

    protected handleSpan(spanString: string, item) {
        const dataTypeString = "data-type='";
        const paramString = "parameters='";
        const dataTypeIndex = spanString.indexOf(dataTypeString);
        const parametersIndex = spanString.indexOf(paramString);
        const endSpanIndex = spanString.indexOf(">");
        const endSpanTagIndex = spanString.indexOf("</span>");

        const dataType = Number(spanString.substring(dataTypeIndex + dataTypeString.length, parametersIndex - 2));
        const parameters = spanString.substring(parametersIndex + paramString.length, endSpanIndex - 1);
        const value = spanString.substring(endSpanIndex + 1, endSpanTagIndex);

        if (dataType == 12 || dataType == 7) {
            if (value && value != null && value != "") {
                let date = moment.utc(value).local();
                if (isNaN(Date.parse(value)) || !date.isValid()) {
                    //date formats that may return invalid date
                    date = moment.utc(value, ["DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY H:mm:ss", "DD/MM/YYYY hh:mm:ss A", "DD/MM/YYYY h:mm:ss A"]).local();
                }

                let datestring = null;

                if (parameters && parameters != null && parameters != "") {
                    datestring = date.format(parameters);
                }
                else {
                    datestring = date.format(dataType == 7 ? "MM/DD/YYYY" : "MM/DD/YYYY HH:mm");
                }

                item.actionDetails = item.actionDetails.replace(spanString, datestring);
            }
            else {
                const spanIndex = item.actionDetails.indexOf(spanString);

                const fromSubstring = item.actionDetails.substring(spanIndex - 5, spanIndex);

                let stringToReplace = spanString;

                if (fromSubstring.indexOf("from") > -1) {
                    stringToReplace = fromSubstring + spanString;
                }

                item.actionDetails = item.actionDetails.replace(stringToReplace, "");
            }
        }
    }

    public refreshData() {
        this.queriesClientService.getData(`${this.configService?.config?.urls?.rightShipPlatformApiUrl}/odata/RightShipAudits/Genesis.GetAudits(entityTypeId=${EntityTypes.Vet},entityId=${this.item.vetId})?$orderby=timestamp desc`).then(x => {
            if (x?.value && x.value.length > 0) {            
                this.audits = x.value;
            } else {
                this.audits = [];
            }            
        });
    }

    getFormattedDate(date) {
        return moment(date).format('DD MMM YYYY HH:mm');
    }

    attached() {
            this.signalClientService.subscribe(SignalFunctions.dueDiligenceHistoryChanged, this.onVetHistoryChanged);
    }


    detached() {
            this.signalClientService.unsubscribe(SignalFunctions.dueDiligenceHistoryChanged, this.onVetHistoryChanged);
    }

    protected onVetHistoryChanged = (params: { vetId: number }) => {
        if (this.item.vetId != params.vetId) return;

        this.refreshData();
    }
}